import React from 'react';
import { Icon, Tooltip, Whisper } from 'rsuite';
import volumeBarBlueIcon from '../../../../../../assets/icons/icon_volume_bar_blue.svg';
import volumeBarGreenIcon from '../../../../../../assets/icons/icon_volume_bar_green.svg';
import volumeBarOrangeIcon from '../../../../../../assets/icons/icon_volume_bar_orange.svg';
import { User } from '../../../../../../@types';
import styles from './ProductFilterMenuRender.module.scss';

type ProductFilterMenuRenderProps = {
  label: string;
  item: {
    datapoints: number;
    limited?: boolean;
    [key: string]: any;
  };
  usuario?: User;
};

const renderVolumeTooltip = (datapoints: number) => {
  const volumeConfig = [
    {
      condition: dp => dp < 30,
      tooltip: 'Alguns dados',
      icon: volumeBarOrangeIcon,
    },
    {
      condition: dp => dp >= 30 && dp < 100,
      tooltip: 'Diversos dados',
      icon: volumeBarBlueIcon,
    },
    {
      condition: dp => dp >= 100,
      tooltip: 'Muitos dados',
      icon: volumeBarGreenIcon,
    },
  ];

  const matched = volumeConfig.find(config => config.condition(datapoints));

  if (!matched) return null;

  const renderTooltip = (message: string, icon: React.ReactNode) => {
    return (
      <Whisper
        placement="top"
        trigger="hover"
        speaker={
          <Tooltip>
            <p>{message}</p>
          </Tooltip>
        }
      >
        {icon}
      </Whisper>
    );
  };

  return renderTooltip(matched.tooltip, <img src={matched.icon} alt={matched.tooltip} className={styles['product-volume-icon']} />);
};

export const ProductFilterMenuRender = ({ label, item, usuario }: ProductFilterMenuRenderProps) => {
  const isLimitUser = usuario?.servicoPanel?.pacotePainel?.name === 'LIMIT';
  const hasAccess = item.limited === false;

  return (
    <div>
      {renderVolumeTooltip(item.datapoints)}

      <span>{label}</span>

      {isLimitUser && hasAccess ? (
        <div
          title="Acesso total"
          style={{
            display: 'inline-block',
            float: 'right',
            color: '#1e88e5',
          }}
        >
          <Icon
            icon="twinkle-star"
            style={{
              fontSize: '16px',
              fontWeight: '600',
            }}
          />
        </div>
      ) : null}
    </div>
  );
};
